<template>
  <div class="Comunicacoes">
    <div class="Comunicacoes_header p-4">
      <SearchComunicacoes @search="getComunicacoes"
                          @showError="displayError" />
    </div>
    <div v-if="registros.length"
         class="Comunicacoes_body">
      <div class="col-12 d-inline-flex justify-content-between align-items-center m-0 p-0 mb-2">
        <div class="d-inline-flex">
          <b-form-checkbox
            id="select_all"
            v-model="select_all"
            name="select_all"
            :value="true"
            class="Comunicacoes_tipos text-capitalize"
            :disabled="!registros.find(registro => registro.status != 'CUMPRIDA')"
            @change="selectAll" />
          <label for="select_all"
                 class="Comunicacoes_label m-0 p-0">
            Selecionar todos
          </label>
        </div>

        <div class="d-inline-flex">
          <div class="d-inline-flex align-items-center mr-4">
            <label for="mostrar"
                   class="Comunicacoes_label m-0 p-0 mr-1">
              Mostrar:
            </label>
            <select id="mostrar"
                    v-model="perPage"
                    class="form-control form-control-sm"
                    @change="reload()">
              <option v-for="(value, index) in [10,20,30,40,50]"
                      :key="index"
                      :value="value">
                {{ value }}
              </option>
            </select>
          </div>
          <div class="d-inline-flex align-items-center">
            <label for="ordenar"
                   class="Comunicacoes_label m-0 p-0 mr-1 text-nowrap">
              Ordernar por:
            </label>
            <select id="ordenar"
                    v-model="orderBy"
                    class="form-control form-control-sm"
                    @change="reload()">
              <option v-for="(order, index) in selects.order"
                      :key="index"
                      :value="order.value">
                {{ order.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <BoxComunicacoes v-for="(registro, index) in registros"
                       :key="index"
                       :prop-registro="registro"
                       :prop-selected="!!selecteds.find(selected => selected.tarefa_id === registro.tarefa_id)"
                       :prop-index="index"
                       class="mb-2"
                       @reload="reload(page)"
                       @addSelected="addSelected"
                       @removeSelected="removeSelected" />
    </div>
    <div v-if="registros.length"
         class="Comunicacoes_action col-12 d-inline-flex justify-content-end align-items-center p-0 m-0 p-4 mt-2">
      <button class="btn btn-sm Comunicacoes_cumprir px-4"
              :disabled="!selecteds.length"
              @click="confirmCumprimento">
        <IconSvg icon="done"
                 class="icon--sm icon_done" />
        Cumprir todas as selecionadas
      </button>
    </div>
    <div v-if="registros.length"
         class="Comunicacoes_footer col-12 justify-content-center align-items-center p-0 m-0 mt-2">
      <Pagination
        :per-page="perPage"
        :page="page"
        :last-page="lastPage"
        @onPreviousPage="reload(page - 1)"
        @onNextPage="reload (page + 1)" />
    </div>

    <b-modal v-if="showModal"
             id="modalErrors"
             ref="modalErrors"
             centered
             size="lg"
             :visible="true"
             hide-header
             @hide="showModal = false">
      {{ success.length }} cumpridas com sucesso e {{ errorsRegistros.length }} erros encontrados
      <hr>
      <h6 class="mb-1">
        Registros com erro:
      </h6>

      <collapse-default v-for="(error, index) in errorsRegistros"
                        :id="`error_${ index }`"
                        :key="`error_${ index }`"
                        :collapse-visible="index == 0">
        <template v-slot:header>
          <span class="mr-2">
            Registro de <span class="text-capitalize">{{ error.nome_registrado | firstCapitalize }}</span>
          </span>
        </template>

        <template v-slot:content>
          <div class="p-2">
            <label class="label">
              Erro do registro:
            </label>
            <div v-html="tratarErros(error.error)" />
          </div>
        </template>
      </collapse-default>
      <div slot="modal-footer"
           class="modalAddGenitor_footer">
        <button class="btn btn-secondary"
                type="button"
                @click="closeModal()">
          OK
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  /* components */
  import BoxComunicacoes from "./BoxComunicacoes"
  import Pagination from "@/components/SofiaRei/Pagination"
  import SearchComunicacoes from "./SearchComunicacoes"
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"

  /* services */
  import GerenciadorService from "@/services/GerenciadorService"
  import ComunicacaoService from "@/services/ComunicacaoService"

  /* libraries */
  import Swal from 'sweetalert2'

  export default {
    name: "Comunicacoes",
    components: {
      BoxComunicacoes,
      Pagination,
      SearchComunicacoes,
      CollapseDefault
    },
    data () {
      return {
        listTypes: [
          {text: 'nascimento', value: 'N', icon: 'nascimento'},
          {text: 'casamento', value: 'D', icon: 'engagement'},
          {text: 'óbito', value: 'O', icon: 'flower'},
        ],
        selects: {
          order: [
            { label: 'Data Inclusão', value: 'data_inclusao' },
            { label: 'Data Registro', value: 'data_registro' },
            { label: 'Data Cumprimento', value: 'data_cumprimento' }
          ]
        },
        registros: [],
        selecteds: [],
        select_all: false,
        page: 1,
        lastPage: 1,
        perPage: 10,
        search: {},
        orderBy: 'data_inclusao',
        errorsRegistros: [],
        success: [],
        showModal: false
      }
    },
    methods: {
      async getComunicacoes (params) {
        try {
          loader({active: true, text: ""})

          //removendo espacos da matricula
          const matricula = params.matricula ? params.matricula.replace(/ /g, '') : null

          this.registros = []
          this.selecteds = []
          this.select_all = false
          this.search = {...params, matricula}

          const res = await GerenciadorService.getTarefas({...params, matricula})

          if (res.data.length) {
            this.registros = res.data
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          } else this.displayError("", "Nenhum registro encontrado!")
        } catch (error) {
          this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      async reload (page = 1) {
        try {
          loader({active: true, text: ""})

          this.select_all = false

          const params = {
            ...this.search,
            page,
            perPage: this.perPage,
            orderBy: this.orderBy
          }

          const res = await GerenciadorService.getTarefas(params)

          if (res.data.length) {
            this.registros = res.data
            this.page = res.page
            this.lastPage = res.lastPage
            this.selecteds = this.selecteds.filter(selected =>
              this.registros.find(registro => registro.tarefa_id === selected.tarefa_id)
            )
          } else if (page > 1) {
            this.reload(this.page - 1)
          }  else  {
            if (page === 1) {
              this.registros = []
              this.page = 1
              this.lastPage = 1
            }

            this.selecteds = []

            this.displayError("", "Nenhum registro encontrado!")
          }
        } catch (error) {
          this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      async confirmCumprimento () {
        if (!this.selecteds.length) {
          return this.displayError("", "Nenhum registro selecionado.")
        }

        const response  = await this.displayQuestion("","", `Confirmar o cumprimento de <b>${this.selecteds.length}</b> tarefas?`)

        if (response.value) this.enviarComunicacoes()
      },
      async enviarComunicacoes () {
        try {
          loader({active: true, text: ""})

          const res = await ComunicacaoService.enviarComunicacoes({tarefas: this.selecteds})

          if (res.errors && res.errors.length) {
            this.errorsRegistros = res.errors
            this.success = res.success
          } else {
            await this.displaySuccess("", "Tarefas cumpridas com sucesso!")
          }

        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ""})

          this.reload(this.page)

          if (this.errorsRegistros.length) this.showModal = true
        }
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then(() => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''
        })
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      displayQuestion (title, text, html) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.html = html
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'
        objSwal.question.input = null
        objSwal.question.inputValue = null
        objSwal.question.inputClass = null
        objSwal.question.inputOptions = null

        return Swal.fire(objSwal.question).then(res => {
          objSwal.question.title = ''
          objSwal.question.text = ''
          objSwal.question.html = ''

          return res
        })
      },
      selectAll () {
        setTimeout (() => {
          if (this.select_all) {
            const selecteds = this.registros.filter(registro => registro.status != "CUMPRIDA")
              .map(registro => registro.tarefa_id)

            this.selecteds = []

            for (const selected of selecteds) {
              this.selecteds.push({tarefa_id: selected})
            }
          } else {
            this.selecteds = []
          }
        }, 100)
      },
      addSelected (tarefa_id) {
        this.selecteds.push({tarefa_id})
      },
      removeSelected (tarefa_id) {
        const index = this.selecteds.findIndex(item => item.tarefa_id === tarefa_id)

        if (index >= 0) {
          this.selecteds.splice(index, 1)
        }
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('#status')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      closeModal () {
        this.showModal = false
        this.errorsRegistros = []
      },
      tratarErros (erros) {
        if (Array.isArray(erros)) {
          const list = `<ul>${erros.map(res => {
            return `<li>${res}</li>`
          })}</ul>`

          return list.replace(/\,/g,'')
        }

        return erros

      }
    }
  }
</script>
<style lang="scss">
  .Comunicacoes {
    &_action {
      border: solid 1px #707070;
      background: #ffffff;
      position: sticky;
      bottom: 10px;
      z-index: 2;
    }

    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 18px;
        height: 18px;
      }
    }

    &_cumprir {
      border: solid 1px #205e3b;
      background: #205e3b;
      font-size: 16px;
      font-weight: normal;
      text-align: center;
      color: #ffffff;
      fill: #FFFFFF;
    }

    &_cumprir:hover {
      color: #FFFFFF;
    }
  }
</style>
